// One shell command, set in mono on a dark block, with a copy button. Copying
// is the point: a member pastes these straight into a terminal.

import { Box, Flex, IconButton, useClipboard } from "@chakra-ui/react";
import { LuCheck, LuCopy } from "react-icons/lu";

const CommandBlock = ({ command }: { command: string }) => {
  const { hasCopied, onCopy } = useClipboard(command);

  return (
    <Flex
      align="center"
      gap="sm"
      bg="neutral.950"
      borderRadius="component.lg" // 8px
      pl="md"
      pr="1xs"
      py="1xs"
    >
      <Box
        as="code"
        flex={1}
        minW={0}
        fontFamily="mono"
        fontSize="sm"
        color="neutral.50"
        overflowX="auto"
        whiteSpace="nowrap"
        py="1xs"
      >
        {command}
      </Box>
      <IconButton
        aria-label={hasCopied ? "Copied" : "Copy command"}
        title={hasCopied ? "Copied" : "Copy command"}
        icon={hasCopied ? <LuCheck /> : <LuCopy />}
        onClick={onCopy}
        size="sm"
        variant="ghost"
        color={hasCopied ? "success.300" : "neutral.300"}
        _hover={{ bg: "whiteAlpha.200", color: "neutral.50" }}
        flexShrink={0}
      />
    </Flex>
  );
};

export default CommandBlock;
